import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CartActions from "../../../../redux/actions/cart.actions";
import cartSelector from "../../../../redux/selectors/cart.selector";

const Coupon = ({ cartList, rate, symbol, currency }) => {
  const dispatch = useDispatch();
  const [couponInput, updateCouponInput] = useState("");
  const [couponInputError, updateCouponInputError] = useState("");
  const couponMessage = useSelector(cartSelector.couponMessage);
  const coupon = useSelector(cartSelector.coupon);
  const couponList = useSelector(cartSelector.couponList);

  useEffect(() => {
    if (coupon) {
      updateCouponInput(coupon.code);
    }
  }, [coupon]);
  const couponInputChange = (e) => {
    updateCouponInputError("");
    updateCouponInput(e.target.value);
  };

  const submitCoupon = () => {
    if (couponInput !== "") {
      dispatch(
        CartActions.applyCouponAction({
          couponCode: couponInput.trim(),
          cartList,
          rate,
          symbol,
          currency,
        }),
      );
    } else {
      updateCouponInputError("Please enter coupon code");
    }
  };

  const removeCoupon = () => {
    updateCouponInput("");
    dispatch(CartActions.removeCouponAction());
  };

  useEffect(() => {
    if (couponList.length > 0) {
      // dispatch(
      //   CartActions.applyCouponAction({
      //     couponCode: couponList[0]?.code,
      //     cartList,
      //     rate,
      //     symbol,
      //     currency,
      //   }),
      // );
    }
  }, [couponList]);

  return (
    <section className="section-card">
      <div className="coupon-section-header">
        <h3>Use Coupon Code</h3>
        <div className="coupon-divider"></div>
      </div>
      <p
        style={{ fontSize: "0.85rem", color: "#666", marginBottom: "1.25rem" }}
      >
        Have a coupon code? Please enter it to avail offers.
      </p>
      <div className="input-group">
        <label
          className="input-label"
          style={{ color: "#c2336a", fontSize: "0.75rem" }}
        >
          * Coupon code is case sensitive
        </label>

        <input
          type="text"
          name="name"
          className="input-field"
          placeholder="Enter coupon"
          value={couponInput}
          onChange={(e) => couponInputChange(e)}
          disabled={coupon !== null}
        />
      </div>
      {couponInputError !== "" && (
        <div className="error">{couponInputError}</div>
      )}
      {couponMessage !== "" && <div className="success">{couponMessage}</div>}
      
      {coupon ? (
        <button
          className="btn-apply-coupon"
          type="button"
          onClick={removeCoupon}
        >
          Remove Coupon
        </button>
      ) : (
        <button
          className="btn-apply-coupon"
          type="button"
          onClick={submitCoupon}
        >
          Apply Coupon
        </button>
      )}
    </section>
  );
};

export default Coupon;
